import React from 'react';
import toString from 'lodash/toString';

import CardImg from '@components/snippets/CardImg';

function ContentPreviewItem({ name, smallThumb, largeThumb, url, duration }) {
  const prepareDuration = () => {
    let hours = Math.trunc(duration / 60);
    let minutes = duration % 60;
    minutes = toString(minutes).length === 1 ? '0' + minutes : minutes;

    return `${hours}:${minutes}`;
  };

  return (
    <div className="content-preview-item">
      <div className="content-preview-item__img">
        <CardImg
          name={name}
          url={url}
          largeThumb={largeThumb}
          smallThumb={smallThumb}
        />
      </div>
      <div className="content-preview-item__duration">{prepareDuration()}</div>
    </div>
  );
}

export default ContentPreviewItem;
